import { AxiosInstance } from 'axios';
import {
  type RfSubscriptionStatus,
  type SubscriptionInfo,
} from 'types/isomorphic/subscription.types';
import apiUrl from '../apiUrl';

export type { RfSubscriptionStatus, SubscriptionInfo };

export class SubscriptionService {
  readonly #httpClient: AxiosInstance;
  readonly baseUrl: string;

  constructor(httpClient: AxiosInstance) {
    this.#httpClient = httpClient;
    this.baseUrl = `${apiUrl}/subscription`;
  }

  getRfSubscriptionStatus = (assetId?: string): Promise<RfSubscriptionStatus> =>
    this.#httpClient
      .get<RfSubscriptionStatus>(`${this.baseUrl}/rf-status`, {
        params: assetId ? { assetId } : undefined,
      })
      .then((response) => response.data);

  getSubscriptionInfo = (family: string): Promise<SubscriptionInfo> =>
    this.#httpClient
      .get<SubscriptionInfo>(`${this.baseUrl}/info`, { params: { family } })
      .then((response) => response.data);
}

export default SubscriptionService;
